import { createSlice, PayloadAction, CaseReducer } from '@reduxjs/toolkit';
import * as Types from './types';

const initialState: Types.AuthState = {
  msisdn: null,
  isAuthorized: false,
  isPending: true,
};

// Reducers
const signInReducer: CaseReducer<Types.AuthState, PayloadAction<Types.SignInPayload>> = (
  state,
  action
) => {
  state.msisdn = action.payload;
  state.isAuthorized = true;
  state.isPending = false;
};

const signOutReducer: CaseReducer<Types.AuthState, PayloadAction> = (state) => {
  state.msisdn = null;
  state.isAuthorized = false;
  state.isPending = false;
};

// Create Slice
const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    signIn: signInReducer,
    signOut: signOutReducer,
  },
});

export const { signIn, signOut } = authSlice.actions;

export default authSlice.reducer;
